<nz-drawer
  [nzWidth]="'90%'"
  [nzClosable]="true"
  [nzVisible]="visibleDriverSldr"
  nzPlacement="right"
  nzTitle="Driver Dashboard"
  (nzOnClose)="visibleDriverSldrclse()"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedDriver) {
    <app-driver-slider [driver]="selectedDriver"></app-driver-slider>
    }
  </ng-container>
</nz-drawer>

@if (showLdr) {
<ds-loading></ds-loading>
}

<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-8 col-md-8">
        @if (clntDtls && clntDtls.length > 0) {
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
      </div>
      <div class="col-lg-4 col-md-4" style="text-align: right">
        <button
          nz-button
          nzType="primary"
          class="adddrvrBtn"
          (click)="opendrvrfrm()"
        >
          Add New Driver
        </button>
      </div>
    </div>
  </div>
</div>

<div class="maindv">
  <div class="fltrbg">
    <div class="row">
      @if (tntLst.length>1) {
      <div class="col-lg-2 col-md-2 crdCl">
        <p class="slctlbl">ULB</p>
        <nz-select
          class="slctBx"
          nzShowSearch
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          nzPlaceHolder="Select ULB"
          [ngModelOptions]="{ standalone: true }"
        >
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          @for (t of tntLst; track t) {
          <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
          }
        </nz-select>
      </div>
      } @if (tntLst && tntLst.length==1) {
      <div class="col-lg-2 col-md-2 crdCl">
        <p class="slctlbl">ULB</p>
        <p class="slctlbl dsblTxt">{{ tntLst[0].tnt_nm }}</p>
      </div>
      } @if (ShowClap) {
      <div class="col-lg-2 col-md-2 crdCl">
        <p class="slctlbl">Vehicle Vendor</p>
        <nz-select
          class="slctBx"
          nzShowSearch
          [(ngModel)]="selectedvndr"
          (ngModelChange)="onvndrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          @if (!showVndr) {
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          } @for (v of vendorList; track v) {
          <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
          }
        </nz-select>
      </div>
      }
      <div class="col-lg-2 col-md-2 crdCl">
        <p class="slctlbl">Search Driver</p>
        <nz-input-wrapper>
          <input
            type="text"
            style="
              height: 32px;
              border-radius: 3px !important;
              background: linear-gradient(135deg, #ffffff 0%, #e7eaec 100%);
              border: 1px solid #d9d9d9;
            "
            nz-input
            [(ngModel)]="searchText"
            placeholder="Search here"
            [ngModelOptions]="{ standalone: true }"
          />
        </nz-input-wrapper>
      </div>
      <div class="col-lg-2 col-md-2 crdCl">
        <p class="slctlbl">Change View</p>
        <div class="crdndtblVw">
          <span>Cards View</span>
          <nz-switch
            [(ngModel)]="switchValue"
            [ngModelOptions]="{ standalone: true }"
            (click)="gridview()"
            class="tgleswtch"
          ></nz-switch>
          <span>Table View</span>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 crdCl">
        <p class="slctlbl">Export from here</p>
        <div class="btnsgrp">
          <button
            nz-button
            nzType="default"
            class="excelbtn"
            (click)="export()"
          >
            <i nz-icon nzType="file-excel" nzTheme="outline"></i>Excel
          </button>
          <!-- <button nz-button nzType="default" class="pdfbtn"><i nz-icon nzType="file-pdf"
        nzTheme="outline"></i>Pdf</button> -->
        </div>
      </div>
    </div>
  </div>

  <div style="padding: 5px">
    @if (crdsview) {
    <div class="row">
      @for (d of drvrslst | driversFilter:searchText; track d) {
      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
        <div class="card_g">
          <div class="card_content">
            <div class="row">
              <div class="col-lg-10 col-md-10" style="padding: 0px">
                <h1
                  class="crdHdr"
                  [ngStyle]="
                    d.clr_obj.clr
                      ? { color: d.clr_obj.clr }
                      : { color: '#424242' }
                  "
                >
                  {{ d.crw_nm }}
                  <span
                    class="own-hired-badge"
                    [ngClass]="{
                      'own-badge': d.own_in == 1,
                      'hired-badge': d.own_in == 2,
                      'apcos-badge': d.own_in == 3
                    }"
                  >
                    {{
                      d.own_in == 1
                        ? "Own"
                        : d.own_in == 2
                        ? "Hired"
                        : d.own_in == 3
                        ? "APCOS"
                        : ""
                    }}
                  </span>
                </h1>
              </div>
              <div
                class="col-lg-1 col-md-1"
                style="padding: 0px"
                (click)="opendrvrlst(d)"
              >
                <i nz-icon nzType="edit" nzTheme="outline" class="icnHvr"></i>
              </div>
              <div
                class="col-lg-1 col-md-1"
                style="padding: 0px"
                (click)="deldrvrlst(d)"
              >
                <i nz-icon nzType="delete" nzTheme="outline" class="icnHvr"></i>
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              @if (!d.crw_img_url || d.crw_img_url == 'undefined') {
              <div
                class="col-lg-3 col-md-3 usr"
                [ngStyle]="
                  d.clr_obj.clr
                    ? { background: d.clr_obj.bgClr }
                    : { background: '#f5f5f5' }
                "
              >
                <i
                  nz-icon
                  nzType="user"
                  nzTheme="outline"
                  [ngStyle]="
                    d.clr_obj.clr
                      ? { color: d.clr_obj.clr }
                      : { color: '#424242' }
                  "
                ></i>
              </div>
              } @if (d.crw_img_url && d.crw_img_url != 'undefined' &&
              d.crw_img_url != null) {
              <div class="col-lg-3 col-md-3">
                <div class="driver-img-circle">
                  <img class="driver-img" [src]="d.crw_img_url" alt="" />
                </div>
              </div>
              }
              <div class="col-lg-9 col-md-9 usrDtls">
                <div class="row">
                  <div class="col-lg-2 col-md-2 mg-a">
                    <i nz-icon [nzType]="'idcard'" [nzTheme]="'outline'"></i>
                  </div>
                  <div class="col-lg-10 col-md-10 mg-a">
                    <h1 class="card_sub_title">
                      {{
                        !d.crw_lcnse_nu ||
                        d.crw_lcnse_nu == "undefined" ||
                        d.crw_ph == null
                          ? "Licence Not Provided"
                          : d.crw_lcnse_nu
                      }}
                    </h1>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2 col-md-2 mg-a">
                    <i nz-icon [nzType]="'calendar'" [nzTheme]="'outline'"></i>
                  </div>
                  <div class="col-lg-10 col-md-10 mg-a">
                    <h1 class="card_sub_title">
                      {{
                        !d.doj || d.doj == "00-00-0000" || d.doj == null
                          ? "DOJ Not Provided"
                          : d.doj
                      }}
                    </h1>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2 col-md-2 mg-a">
                    <i
                      nz-icon
                      [nzType]="'phone'"
                      [nzTheme]="'outline'"
                      [nzRotate]="90"
                    ></i>
                  </div>
                  <div class="col-lg-10 col-md-10 mg-a">
                    <h1 class="card_sub_title">
                      {{
                        !d.crw_ph || d.crw_ph == 0 || d.crw_ph == null
                          ? "Mobile Number Not
                        Provided"
                          : d.crw_ph
                      }}
                    </h1>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2 col-md-2 mg-a">
                    <i nz-icon [nzType]="'car'" [nzTheme]="'outline'"></i>
                  </div>
                  <div class="col-lg-10 col-md-10 mg-a">
                    <h1 class="card_sub_title">
                      {{
                        !d.asrt_nm ||
                        d.asrt_nm == "undefined" ||
                        d.asrt_nm == null
                          ? "No Vehicle Assigned For this Driver"
                          : d.asrt_nm
                      }}
                    </h1>
                  </div>
                </div>
                <div
                  class="row"
                  (click)="gotoDrvrSldr(d)"
                  style="cursor: pointer"
                >
                  <div class="col-lg-2 col-md-2 mg-a">
                    <i nz-icon [nzType]="'dashboard'" [nzTheme]="'outline'"></i>
                  </div>
                  <div class="col-lg-10 col-md-10 mg-a">
                    <h1 class="card_sub_title">Quick view</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="driverCrds">
          <div (click)="opendrvrlst(d)">
            <div class="drvrName">{{d.crw_nm}}</div>
            <div class="inrcntnt">
              <div class="row">
                <div class="col-md-9">
                  <div class="licenceno">
                    <i nz-icon [nzType]="'idcard'" [nzTheme]="'outline'"></i>
                    Licence No: <span class="bldFnt">{{d.crw_lcnse_nu == "undefined" ? '': d.crw_lcnse_nu}}</span>
                  </div>
                  <div class="dteofjn">
                    <i nz-icon [nzType]="'calendar'" [nzTheme]="'outline'"></i>
                    DOJ:<span class="bldFnt">{{d.doj == "00-00-0000" ? '' : d.doj}}</span>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                  <div class="drvrimg" [ngStyle]="{'background': getRandomColor()}" style="opacity: .5;">
                    <img src="assets/images/delivery-man.png">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ftrcntnt">
            <div class="row">
              <div class="col-md-6 brdrgt">
                <div class="vhcleDshbrd">
                  <a href="internal/dashboard"> <i nz-icon [nzType]="'dashboard'" [nzTheme]="'outline'"></i> Drivers
                Dashboard</a>
              </div>
            </div>
            <div class="col-md-6">
              <div class="drvrphno">
                <i nz-icon [nzType]="'phone'" [nzTheme]="'outline'" [nzRotate]="90"></i>
                {{d.crw_ph == 0 ? '': d.crw_ph}}
              </div>
            </div>
          </div>
        </div>
      </div> -->
      </div>
      }
      <nz-drawer
        [nzBodyStyle]="{ overflow: 'auto' }"
        [nzMaskClosable]="false"
        [nzWidth]="380"
        [nzVisible]="visible"
        nzTitle="Driver Details"
        (nzOnClose)="closedrvrlst()"
      >
        <!-- [nzFooter]="footerTpl" -->
        <ng-container *nzDrawerContent>
          <form nz-form [formGroup]="driverform" class="drvrDtlsfrm">
            <div nz-row [nzGutter]="8">
              <div nz-col nzSpan="24">
                <nz-form-label>Driver Staff ID</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="drvr_stf_id"
                      placeholder="staff ID"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label>Driver Name</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="drvr_nm"
                      placeholder="Driver name"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label>Driver Phone No</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="drvr_phn_no"
                      placeholder="Phone Number"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label>Licence Number</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="drvr_lcnce_nm"
                      placeholder="Licence Number"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label>Date of Join</nz-form-label>
                <nz-form-item>
                  <nz-date-picker
                    formControlName="dt_of_jn"
                    nzFormat="dd-MM-yyyy"
                  ></nz-date-picker>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="24">
                <nz-form-label nzRequired>Driver Type</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <nz-select
                      formControlName="own_in"
                      nzPlaceHolder="Select Driver Type"
                    >
                      <nz-option [nzValue]="1" nzLabel="Own"></nz-option>
                      <nz-option [nzValue]="2" nzLabel="Hired"></nz-option>
                      <nz-option [nzValue]="3" nzLabel="APCOS"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <!-- Driver Image Upload Section -->
            <div nz-col nzSpan="24" style="margin-bottom: 12px">
              <nz-form-label>Driver Photo</nz-form-label>
              <nz-form-item>
                <nz-form-control>
                  <!-- If no image, show upload -->
                  @if (!driverImagePreview && !driverform.value.crw_img_url) {
                  <input
                    type="file"
                    accept="image/*"
                    (change)="onDriverImageChange($event)"
                  />
                  }
                  <!-- If image exists, show preview and change option -->
                  @if (driverImagePreview || driverform.value.crw_img_url) {
                  <div style="margin-bottom: 8px">
                    <img
                      [src]="driverImagePreview || driverform.value.crw_img_url"
                      alt="Driver Image"
                      style="
                        max-width: 120px;
                        max-height: 120px;
                        border-radius: 8px;
                        border: 1px solid #eee;
                      "
                    />
                  </div>
                  <button
                    nz-button
                    nzType="default"
                    (click)="$event.preventDefault(); imageInput.click()"
                  >
                    Change Photo
                  </button>
                  <input
                    #imageInput
                    type="file"
                    accept="image/*"
                    style="display: none"
                    (change)="onDriverImageChange($event)"
                  />
                  @if (driverImagePreview) {
                  <button
                    nz-button
                    nzType="default"
                    nzDanger
                    style="margin-left: 8px"
                    (click)="removeDriverImage()"
                  >
                    Remove
                  </button>
                  } }
                </nz-form-control>
              </nz-form-item>
            </div>
          </form>
          <!-- <ng-template #footerTpl>
          <div > -->
          <div class="btngrp">
            <button
              nz-button
              style="margin-right: 8px"
              (click)="closedrvrlst()"
              nzType="primary"
              nzDanger
            >
              Cancel
            </button>
            <button
              nz-button
              (click)="subDrvrlst()"
              [nzLoading]="isSaving"
              [disabled]="isSaving || !driverform.valid || !perms.canWrite()"
              [title]="
                !perms.canWrite() ? 'You do not have permission to save' : ''
              "
              class="sbmtbtn"
            >
              {{ isSaving ? "Saving..." : "Submit" }}
            </button>
          </div>
          <!-- </div>
        </ng-template> -->
        </ng-container>
      </nz-drawer>
    </div>
    }

    <!-- <div class="row" *ngIf="tblview">
<div class="col-md-12">
  <nz-table #middleTable nzSize="middle" class="drvrlstTbl" [nzData]="drvrslst" [nzPageSize]="20">
    <thead>
      <tr>
        <th>Sno</th>
        <th>Driver Name</th>
        <th>Licence No</th>
        <th>DOJ</th>
        <th>Mobile No</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let d of drvrslst | filter:searchText let i=index">
        <td>{{i + 1}}</td>
        <td>{{d.crw_nm}}</td>
        <td>{{d.crw_lcnse_nu}}</td>
        <td>{{d.doj}}</td>
        <td>{{d.crw_ph}}</td>
      </tr>
    </tbody>
  </nz-table>
</div>
</div> -->

    @if (tblview) {
    <div class="ds-card grid tbl dwntbl drvrsCmpnt">
      <app-data-grid
        class="p-8"
        style="width: 100%"
        [dataSource]="drvrslst"
        [legacyColumns]="drvrslstcolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="Drivers List Data"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="true"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoSldr(data)">
              <i
                nz-icon
                [nzType]="'dashboard'"
                [nzTheme]="'outline'"
                style="font-size: 11px"
              ></i>
              &nbsp;&nbsp;<span
                style="
                  font-size: 11px;
                  text-transform: capitalize;
                  font-weight: 500;
                "
                >View</span
              >
            </div>
          </div></ng-template
        >
        <!--
      <app-grid-column [showInColumnChooser]="false" [visible]="false" type="buttons"
      [width]="100" caption="Edit" cellTemplate="editTemplate"></app-grid-column>
      <app-grid-column [showInColumnChooser]="false" [visible]="false" type="buttons"
      [width]="100" caption="Delete" cellTemplate="delTemplate"></app-grid-column>
      -->
      </app-data-grid>
    </div>
    }
  </div>

  <!-- sidebar service -->
  <!-- <div class="adnewdrvr" *ngIf="shwdrvrfrm"> -->
  <nz-drawer
    [nzBodyStyle]="{ overflow: 'auto' }"
    [nzMaskClosable]="false"
    [nzWidth]="380"
    [nzVisible]="visible"
    nzTitle="Driver Details"
    (nzOnClose)="closedrvrlst()"
  >
    <!-- [nzFooter]="footerTpl" -->
    <form nz-form [formGroup]="addrvrfrm" class="drvrDtlsfrm">
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-label>Name</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                formControlName="drvrnm"
                placeholder="Enter Driver Name"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-label>Phone Number</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                formControlName="phnmb"
                placeholder="Enter Phone Number"
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="24">
          <nz-form-label>ID Number</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                formControlName="drvrid"
                placeholder="Enter Driver Id"
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="24">
          <nz-form-label>Licence Number</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                formControlName="lcncnmb"
                placeholder="Enter Driver Licence Id"
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="24">
          <nz-form-label>Date of Join</nz-form-label>
          <nz-form-item>
            <nz-date-picker
              formControlName="doj"
              nzFormat="dd-MM-yyyy"
              placeholder="Select Date of Joining"
            ></nz-date-picker>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="24">
          <nz-form-label nzRequired>Driver Type</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                formControlName="own_in"
                nzPlaceHolder="Select Driver Type"
              >
                <nz-option [nzValue]="1" nzLabel="Own"></nz-option>
                <nz-option [nzValue]="2" nzLabel="Hired"></nz-option>
                <nz-option [nzValue]="3" nzLabel="APCOS"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <!-- <ng-template #footerTpl>
  <div > -->

    <div class="btngrp">
      <button
        nz-button
        style="margin-right: 8px"
        (click)="bckbtn()"
        nzType="primary"
        nzDanger
      >
        Cancel
      </button>
      <button
        nz-button
        (click)="addDrvr()"
        [nzLoading]="isSaving"
        [disabled]="isSaving || !addrvrfrm.valid || !perms.canWrite()"
        [title]="!perms.canWrite() ? 'You do not have permission to save' : ''"
        class="sbmtbtn"
      >
        {{ isSaving ? "Saving..." : "Save Driver" }}
      </button>
    </div>
    <!-- </div>
</ng-template> -->
  </nz-drawer>
  <!-- </div> -->
</div>
